import { getPercentileAttributes, getPercentileAttributesConstants } from '../../api/dashboards-api';

export const CUTOFF_HR = 1;
export const CUTOFF_R = 2;
export const CUTOFF_RWC = 3;
export const CUTOFF_DNR = 4;

export const GREEN_YELLOW_RED_COLORS = {
  doNotRecommend: {
    primary: '#e03c32',
    secondary: '#ffd6d6',
  },
  recommendWithCaution: {
    primary: '#ffd301',
    secondary: '#ffe999',
  },
  recommend: {
    primary: '#375623',
    secondary: '#c4e0b1',
  },
  highlyRecommend: {
    primary: '#00b050',
    secondary: '#ceefbd',
  },
};
export const BLUE_COLORS = {
  doNotRecommend: {
    primary: '#0aa8fe',
    secondary: '#b7e5ff',
  },
  recommendWithCaution: {
    primary: '#0770a9',
    secondary: '#9BDCFF',
  },
  recommend: {
    primary: '#033854',
    secondary: '#86d4ff',
  },
  highlyRecommend: {
    primary: '#033854',
    secondary: '#86d4ff',
  },
};
export const getRecommendationCutoff = (candidate, location) => {
  const percentiles = candidate.percentiles;

  const percentileAttributes = location ? getPercentileAttributesConstants()[location] : getPercentileAttributes();

  if (percentiles[percentileAttributes.performance] < 33 || percentiles[percentileAttributes.loyalty] < 33) {
    return CUTOFF_DNR;
  }

  if (percentiles[percentileAttributes.performance] >= 66) {
    if (percentiles[percentileAttributes.loyalty] >= 66) {
      return CUTOFF_HR;
    }
    if (percentiles[percentileAttributes.loyalty] >= 33) {
      return CUTOFF_R;
    }
  }

  if (percentiles[percentileAttributes.performance] >= 33) {
    if (percentiles[percentileAttributes.loyalty] >= 66) {
      return CUTOFF_R;
    }
    if (percentiles[percentileAttributes.loyalty] >= 33) {
      return CUTOFF_RWC;
    }
  }

  return CUTOFF_DNR;
};

export const getNineBoxRecommendationCutoff = (candidate) => {
  const percentiles = candidate.percentiles;

  const percentileAttributes = getPercentileAttributes();

  if (percentiles[percentileAttributes.performance] >= 66) {
    if (percentiles[percentileAttributes.loyalty] >= 66) {
      return CUTOFF_HR;
    }
    if (percentiles[percentileAttributes.loyalty] >= 33) {
      return CUTOFF_R;
    }
    return CUTOFF_RWC;
  }

  if (percentiles[percentileAttributes.performance] >= 33) {
    if (percentiles[percentileAttributes.loyalty] >= 66) {
      return CUTOFF_R;
    }
    if (percentiles[percentileAttributes.loyalty] >= 33) {
      return CUTOFF_RWC;
    }
    return CUTOFF_DNR;
  }

  if (percentiles[percentileAttributes.loyalty] >= 66) {
    return CUTOFF_RWC;
  }
  if (percentiles[percentileAttributes.loyalty] >= 33) {
    return CUTOFF_DNR;
  }
  return CUTOFF_DNR;
};

export const getNineBoxValue = (candidate) => {
  const percentiles = candidate.percentiles;

  const percentileAttributes = getPercentileAttributes();

  if (percentiles[percentileAttributes.performance] >= 66) {
    if (percentiles[percentileAttributes.loyalty] >= 66) {
      return 2;
    }
    if (percentiles[percentileAttributes.loyalty] >= 33) {
      return 5;
    }
    return 8;
  }

  if (percentiles[percentileAttributes.performance] >= 33) {
    if (percentiles[percentileAttributes.loyalty] >= 66) {
      return 1;
    }
    if (percentiles[percentileAttributes.loyalty] >= 33) {
      return 4;
    }
    return 7;
  }

  if (percentiles[percentileAttributes.loyalty] >= 66) {
    return 0;
  }
  if (percentiles[percentileAttributes.loyalty] >= 33) {
    return 3;
  }
  return 6;
};

export const getNineBoxSortValue = (candidate) => {
  const percentiles = candidate.percentiles;

  const percentileAttributes = getPercentileAttributes();

  if (percentiles[percentileAttributes.performance] >= 66) {
    if (percentiles[percentileAttributes.loyalty] >= 66) {
      // 2, 0
      return 0;
    }
    if (percentiles[percentileAttributes.loyalty] >= 33) {
      // 5, 1
      return 1;
    }
    // 8, 4
    return 4;
  }

  if (percentiles[percentileAttributes.performance] >= 33) {
    if (percentiles[percentileAttributes.loyalty] >= 66) {
      // 1, 2
      return 2;
    }
    if (percentiles[percentileAttributes.loyalty] >= 33) {
      // 4, 3
      return 3;
    }
    // 7, 6
    return 6;
  }

  if (percentiles[percentileAttributes.loyalty] >= 66) {
    // 0, 5
    return 5;
  }
  if (percentiles[percentileAttributes.loyalty] >= 33) {
    // 3, 7
    return 7;
  }
  // 6, 8
  return 8;
};
